import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Input } from '../../../../../../components/common-inputs';

import scss from '../AssetPreviewModal.module.scss';

const FONT_PREVIEW_SIZES = [48, 28, 16];

function FontPreview({ font }) {
  const { t } = useTranslation('settings');
  const [sample, setSample] = useState(t('mediaStudioFontSample'));

  return (
    <div className={scss.fontPreview}>
      <h3 className={scss.fontName}>{font.label}</h3>

      <Input value={sample} placeholder={t('mediaStudioFontSampleLabel')} onChange={setSample} />

      <div className={scss.fontLines} style={{ fontFamily: font.stack }}>
        {FONT_PREVIEW_SIZES.map((size) => (
          <p key={size} style={{ fontSize: size }}>
            {sample}
          </p>
        ))}
      </div>

      <p className={scss.fontDisclaimer}>{t('mediaStudioFontAvailable')}</p>
    </div>
  );
}

export default FontPreview;
